export const RESET_PASSWORD = 'core/logins/reset-password';
